module.exports = __webpack_public_path__ + "static/img/1_1_5.fb6b6039.jpg";